export const getSongId = (song = {}) => song?.id || song?.song_id || song?.songId || null;

const isActiveStatus = (value) => {
  if (value === undefined || value === null || value === '') return true;
  return value === 1 || value === '1' || value === 'Active' || value === 'active' || value === true;
};

const isNotDeleted = (value) => {
  if (value === undefined || value === null || value === '') return true;
  return value === 0 || value === '0' || value === false;
};

export const isActiveAlbumSong = (song = {}) => {
  const status = song?.status ?? song?.song_status ?? song?.songStatus ?? song?.songalbum_status ?? song?.album_status;
  const isDeleted = song?.is_delete ?? song?.is_deleted ?? song?.isDelete ?? song?.isDeleted ?? song?.songalbum_is_delete;
  return isActiveStatus(status) && isNotDeleted(isDeleted);
};

export const paginateItems = (items = [], page = 1, pageSize = 20) => {
  const safePage = Math.max(1, Number(page) || 1);
  const safePageSize = Math.max(1, Number(pageSize) || 20);
  const startIndex = (safePage - 1) * safePageSize;
  return items.slice(startIndex, startIndex + safePageSize);
};

export const collectAlbumDocuments = (songs = [], ownershipBySongId = {}) => {
  const docs = [];

  console.log('[collectAlbumDocuments] Starting collection with', songs.length, 'songs and ownership map:', Object.keys(ownershipBySongId));

  songs.forEach((song, idx) => {
    if (!isActiveAlbumSong(song)) {
      console.log(`[collectAlbumDocuments] Song ${idx} filtered out (not active)`);
      return;
    }

    const songId = getSongId(song);
    if (!songId) {
      console.log(`[collectAlbumDocuments] Song ${idx} has no ID`);
      return;
    }

    console.log(`[collectAlbumDocuments] Processing song ${songId}:`, song.name);

    const ownership = song.ownership || ownershipBySongId[songId] || {};
    console.log(`[collectAlbumDocuments] Ownership data for song ${songId}:`, ownership);

    const groups = [
      { key: 'recordLabels', type: 'Recode label', label: 'recordLabels' },
      { key: 'lyrics', type: 'Lyrics', label: 'lyrics' },
      { key: 'musicians', type: 'Melody', label: 'musicians' },
      { key: 'singers', type: 'Singer', label: 'singers' }
    ];

    groups.forEach(({ key, type }) => {
      const items = Array.isArray(ownership[key]) ? ownership[key] : [];
      console.log(`[collectAlbumDocuments] Group "${key}": found ${items.length} items`);
      
      items.forEach((item) => {
        const docObj = {
          id: item.mappingId || item.id || `${songId}-${key}-${Math.random()}`,
          songId,
          songName: song.name || song.title || 'Untitled Song',
          name: item.name || item.document_name || item.documentName || `${type} Document`,
          type,
          size: item.size || item.document_size || 'PDF Document',
          date: item.createdAt || item.created_at || item.updatedAt || item.updated_at || '',
          documentUrl: item.document_url || item.documentUrl || item.file_url || item.url || '',
          rawName: item.rawName || item.name || item.document_name || item.documentName || `${type} Document`,
          category: key,
          mappingId: item.mappingId || item.id || null,
          artist: item.artist || item.artistName || item.artist_name || null
        };
        console.log(`[collectAlbumDocuments] Adding document:`, docObj.name, 'from song', songId);
        docs.push(docObj);
      });
    });
  });

  console.log('[collectAlbumDocuments] Final collected documents:', docs.length);
  return docs;
};
